'use strict';

var Button = require('./Button.js');



module.exports = Button["default"];
